<template>
  <ul class="p-5">
    <router-link v-for="(item, index) in components" :key="index" :to="item.toLowerCase()" tag="li">
      <a>
        <h5>{{ item }}</h5>
      </a>
    </router-link>
  </ul>
</template>

<script>
export default {
  data() {
    return {
      components: ['Alert', 'Header', 'Sidebar', 'CtaButton'],
    };
  },
};
</script>
